export function mergeChatMessages(localMessages = [], remoteMessages = []) {
    return [
        ...remoteMessages,
        ...localMessages.filter(
            lc => !remoteMessages.find(rc => rc.id === lc.id)
        )
    ].sort(
        (a, b) =>
            new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
    );
}
